// Colored initials avatar circle for member table rows
import React from 'react';
import { cn } from 'lib/utils';

const bgColors = [
  'tw-bg-blue-500', 'tw-bg-green-500', 'tw-bg-purple-500',
  'tw-bg-amber-500', 'tw-bg-rose-500', 'tw-bg-cyan-500',
  'tw-bg-indigo-500', 'tw-bg-teal-500',
];

const getColorIndex = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % bgColors.length;
};

const MemberAvatar = ({ firstName = '', lastName = '' }) => {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  const colorClass = bgColors[getColorIndex(`${firstName}${lastName}`)];

  return (
    <div
      className={cn(
        'tw-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-full tw-text-white tw-text-xs tw-font-semibold tw-flex-shrink-0',
        colorClass
      )}
      aria-label={`${firstName} ${lastName}`}
    >
      {initials}
    </div>
  );
};

export default MemberAvatar;
